import React, { Fragment } from 'react';

// eslint-disable-next-line jira/restricted/styled-components-migration, @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
// eslint-disable-next-line jira/restricted/@atlassian+jira-common-styles
import { gridSize } from '@atlassian/jira-common-styles/src';
import type { ItemProviderDataSection } from '../../types/item-provider';

import Item from './item';
import { hasItems } from './utils';

type Props = {
	sections: ItemProviderDataSection[];
	showStar?: boolean;
	onItemClick?: () => void;
};

const ItemList = ({ sections, showStar, onItemClick }: Props) => (
	<List>
		{sections.filter(hasItems).map((section, i) => {
			const { header = '' } = section;

			return (
				<Fragment key={`${header}-${i}`}>
					{header ? <SectionHeader headerIndex={i}>{header}</SectionHeader> : null}

					{section.items.map((item, index) => (
						<Item
							item={item}
							index={index}
							key={item.url}
							showStar={showStar}
							onItemClick={onItemClick}
						/>
					))}
				</Fragment>
			);
		})}
	</List>
);

export default ItemList;

/**
 * Matches the globally-applied <h6> styles from
 * "com.atlassian.auiplugin:aui-page-typography",
 *
 * Undoing the globally-applied WRM stylesheet from
 * "com.atlassian.jira.jira-atlaskit-plugin:overrides-general".
 */
const matchGlobalH3Color = () => `color: ${token('color.text.subtlest', colors.N200)} !important;`;

/* The first header needs to be rendered as a normal h6 without any top margin */
const getTopMargin = (props: { headerIndex: number }) =>
	props.headerIndex === 0 ? gridSize : gridSize * 2;

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const List = styled.div<any>({
	display: 'flex',
	flexDirection: 'column',
	width: '100%',
	marginTop: token('space.100', '8px'),
});
List.defaultProps = {
	'data-test-id': 'global-pages.home.common.ui.item-list.list',
};

// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/compiled/styled-components-usages, jira/styled/no-styled-export, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SectionHeader = styled.h3<any>`
	${matchGlobalH3Color};
	margin-top: ${getTopMargin}px !important;
	font-weight: 600;
	font-size: 0.8571428571428571em;
	line-height: 1.3333333333333333;
	text-transform: uppercase;
	letter-spacing: normal;
`;
